//@author: travis
import { ChangeDetectionStrategy, Component, Input, NgZone, OnInit, ViewEncapsulation } from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { SearchCriteriaService } from "../../../services/search/search-criteria/search.criteria.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-category-dropdown")
@Component({
    selector: "s25-category-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [hasFav]="false"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="true"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [serverSide]="serverSide"
                [placeholder]="'Select a Category'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
            />
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25CategoryDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() itemTypeId: number;

    constructor(private zone: NgZone) {
        super();
    }

    ngOnInit() {
        const value = this.value();
        if (value) {
            value.itemTypeId = this.itemTypeId;
        }
        SearchCriteriaService.getObjectCategories(this.itemTypeId).then((data) => {
            this.zone.run(() => {
                this.items = data;
                this.onLoad && this.onLoad();
            });
        });
    }
}
